import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { PlayerAvatar } from "./PlayerAvatar";
import { PlayerDisplayNameLink } from "./PlayerDisplayNameLink";
import { isRegisteredPlayer } from "./utils";
export const PlayerView = ({ player, variant = "h5", }) => {
    return (_jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(PlayerAvatar, { player: player, verified: isRegisteredPlayer(player) }), _jsx(Typography, { variant: variant, children: _jsx(PlayerDisplayNameLink, { player: player }) })] }));
};
